import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import Markdown from "components/shared/Markdown";

const Notes = (props) => {
  const {children, label, type} = props;
  if (!children) {
    return null;
  }

  return (
    <div
      className={classnames("alert", `alert-${type}`)}
      style={{borderRadius: 0}}>
      <div className="text-uppercase"><strong>{label}</strong></div>
      <Markdown>{children}</Markdown>
    </div>
  );
};

Notes.defaultProps = {
  type: "info",
};
Notes.propTypes = {
  children: PropTypes.string,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    "danger", "info", "scheduler", "success", "warning",
  ]),
};

export default Notes;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/Notes.js
 **/